import { React, useState } from 'react';
import {
  Label,
  TextInput,
  Button,
  Flowbite,
  Datepicker,
  Radio,
} from 'flowbite-react';
import {
  buttonTheme,
  centerText,
  datePickerTheme,
  Footer,
} from '../components/themes.js';
import { getUserInfo } from '../firebase/FirebaseManagement.js';
import { BiCurrentLocation } from 'react-icons/bi';
import { MdLocationOn } from 'react-icons/md';
import { createRide } from '../firebase/FirebaseManagement.js';
import { Store } from 'react-notifications-component';
import { useNavigate } from 'react-router-dom';
export default function CreateRide() {

    const [seats, setSeats] = useState(1)
    const [price, setPrice] = useState(null)
    const [type, setType] = useState('driver')
    const [date, setDate] = useState()
    const [time, setTime] = useState("")
    const [departure, setDeparture] = useState('')
    const [destination, setDestination] = useState('')
    const [amPM, setAmPM] = useState('AM')
    
    const navigate = useNavigate();

  

  const handleAddSeats = () => {
    setSeats(seats + 1);
  };
  const handleReduceSeats = () => {
    if (seats > 1) {
      setSeats(seats - 1);
    }
  };


  const handleTimeChange = (e) => {
    let value = e.target.value;
    const reg = /^[0-9:]*$/;
    if (!reg.test(value)) {
      return;
    }
    if (value.length === 2 && !value.includes(':')) {
      value += ':';
    }
    if (value.length <= 5) {
      setTime(value);
    }
    }

    
    const handleCreateRide = async (e) => {
        e.preventDefault();
        try {
            const userInfo = await getUserInfo(localStorage.getItem("userId"))
           
            const ride = {
                departure: departure,
                destination: destination,
                seats: seats,
                price: price,
                date: date,
                type: type,
                passengers: [],
                time: `${time} ${amPM}`,
                driver: userInfo.uid
            }
            console.log(ride)
            const res = await createRide(ride)
            console.log(res)
            if(res) {
                console.log(res)
                Store.addNotification({
                    title: "Wonderful!",
                    message: "Your RexRide was created successfully!",
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                        duration: 5000,
                        showIcon: true
                    }
                  });
                  navigate("/myrides")
               
            }
        } catch (error) {
            console.log(error)
        }

    }

    

    
  


  return (
    <div className="box-container flex flex-col items-center md:w-[500px] justify-center mx-auto">
      <h1 className="text-3xl">
        Create Rex<span className="span-titles">Ride</span>
      </h1>
      <form onSubmit={handleCreateRide} className="flex flex-col gap-[20px]">
        <div>
          <legend className="mb-4">
            <p>
              Rex<span>Ride</span> type
            </p>
          </legend>
          <div
            className="flex items-center gap-2 mb-4"
            onClick={() => {
              setType('driver');
            }}
          >
            <Radio defaultChecked id="driver" name="type" value="driver" />
            <Label htmlFor="driver">Driver</Label>
          </div>
          <div
            className="flex items-center gap-2"
            onClick={() => {
              setType('passanger');
              setPrice(null);
            }}
          >
            <Radio id="passanger" name="type" value="passanger" />
            <Label htmlFor="passanger">Passanger</Label>
          </div>
        </div>
        <div>
          <Label value="Departure" htmlFor="departure"></Label>
          <TextInput
            id="departure"
            shadow="true"
            icon={BiCurrentLocation}
            onChange={(e) => setDeparture(e.target.value)}
          ></TextInput>
        </div>
        <div>
          <Label value="Destination" htmlFor="destination"></Label>
          <TextInput
            id="destination"
            shadow="true"
            icon={MdLocationOn}
            onChange={(e) => setDestination(e.target.value)}
          ></TextInput>
        </div>

        <div>
          <Label value="Seats"></Label>
          <div className="flex gap-[10px]">
            <Flowbite theme={{ theme: buttonTheme }}>
              <Button color="primary" onClick={handleReduceSeats}>
                -
              </Button>
            </Flowbite>
            <Flowbite theme={{ theme: centerText }}>
              <TextInput
                readOnly
                id="seats"
                placeholder={seats}
                type="text"
                color="primary"
                shadow="true"
              />
            </Flowbite>
            <Flowbite theme={{ theme: buttonTheme }}>
              <Button color="primary" onClick={handleAddSeats}>
                +
              </Button>
            </Flowbite>
          </div>
        </div>
        <div>
          {type === 'driver' ? (
            <>
              <Label value="Price"></Label>
              <TextInput
                addon="$"
                id="price"
                placeholder={'0.00'}
                type="text"
                onChange={(e) => setPrice(e.target.value)}
                shadow="true"
              />
            </>
          ) : (
            ''
          )}
        </div>

        <div>
          <Flowbite theme={{ theme: datePickerTheme }}>
            <Label>Date</Label>
            <Datepicker
              showClearButton={false}
              minDate={new Date()}
              onSelectedDateChanged={(value) => setDate(value)}
            />
          </Flowbite>
        </div>
        <div>
          <Label>Time</Label>
          <div className="flex gap-4">
            <TextInput
              placeholder="HH:MM"
              id="time"
              className="w-[70px]"
              type="text"
              value={time}
              shadow="true"
              onChange={handleTimeChange}
            />
            <Flowbite theme={{ theme: buttonTheme }}>
              <Button.Group>
                <Button
                  color={amPM === 'AM' ? 'primary' : 'secondary'}
                  onClick={() => setAmPM('AM')}
                >
                  AM
                </Button>
                <Button
                  color={amPM === 'PM' ? 'primary' : 'secondary'}
                  onClick={() => setAmPM('PM')}
                >
                  PM
                </Button>
              </Button.Group>
            </Flowbite>
          </div>
        </div>
        <Flowbite theme={{ theme: buttonTheme }}>
          <Button color="primary" type="submit" className="w-full mt-3">
            Create Rex Ride
          </Button>
        </Flowbite>
      </form>
        <footer/>
    </div>
  );
}
